module.exports = __webpack_public_path__ + "static/media/page07_org.e864ab68.jpg";